module.exports = __webpack_public_path__ + "0086896739720d4f9b5eb5dc825e584d.svg";